import React from 'react';
import moment from 'moment';

export default class AccrualByPlacementMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isElementVisible: [],

        }
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.expandApprover = this.expandApprover.bind(this);
    }

    toggleVisibility(index) {
        let isElementVisible = this.state.isElementVisible.slice(0);
        isElementVisible[index] = !isElementVisible[index];
        this.setState({ isElementVisible });
    }
    
    expandApprover(approverId) {
        if (this.props.onExpandApprover)
            this.props.onExpandApprover(approverId);
    }

    render() {
        let list = this.props.items;
        let content = [];
        for (let i = 0, rowNo = 0; i < list.length; i++) {
            let item = list[i];

            let accruals = item.accrualSummaryList;
            if (accruals == null || accruals.length == 0) {
                content.push(
                    <div className={`row ap-accrualgrid-detail-${i%2}`} key={`${i}_0`}>
                        {   item.approverId?
                                [<div key="col_0" className="col-xs-2 text-left ap-text-bold employee-name" title={item.placement.fullName}>
                                    {item.placement.fullName}
                                </div>,
                                <div key="col_1" className="col-xs-1 text-right ap-text-bold">
                                    <a href="#" onClick={() => this.expandApprover(item.approverId)}>{`${item.employeeCount} Staff`}</a>
                                </div>,
                                <div key="col_2" className="col-xs-9">
                                </div>]
                                :
                                [<div key="col_0" className="col-xs-12 text-left ap-text-bold employee-name">
                                    {item.placement.fullName}
                                </div>]
                        }
                    </div>
                );
                rowNo++;
                continue;
            }

            for (let j = 0; j < accruals.length; j++) {
                let idx = rowNo;
                let summary = accruals[j];
                const showAccruedHrs = (summary.isVisibleToUser === true);

                content.push(
                    <div className={`row ap-accrualgrid-detail-${i%2}`} key={`${i}_${j}`}>
                        {   item.approverId?
                                [<div key="col_0" className="col-xs-2 text-left ap-text-bold employee-name" title={j == 0 ? item.placement.fullName : ""}>
                                    {j == 0 ? item.placement.fullName : ""}
                                </div>,
                                <div key="col_1" className="col-xs-1 text-right ap-text-bold">
                                    {j == 0 ? <a href="#" onClick={() => this.expandApprover(item.approverId)}>{`${item.employeeCount} Staff`}</a> : null}
                                </div>]
                                :
                                [<div key="col_0" className="col-xs-3 text-left ap-text-bold employee-name" title={j == 0 ? item.placement.fullName : ""}>
                                    {j == 0 ? item.placement.fullName : ""}
                                </div>]
                        }
                        <div className="col-xs-3 text-left leave-group">
                            <span onClick={() => this.toggleVisibility(idx)} className={this.state.isElementVisible[idx] ? "fa fa-minus-square-o ap-good-color ap-pointer" : " fa fa-plus-square-o ap-good-color ap-pointer"}> </span>&nbsp;
                            {summary.accrualDescription}
                        </div>
                        <div className="col-xs-2 unit">
                            {showAccruedHrs ? summary.totalAccruedHours : ""}
                        </div>
                        <div className="col-xs-2 unit">
                            {summary.loggedHours}
                        </div>
                        <div className="col-xs-2 unit">
                            {showAccruedHrs ? summary.availableHours : ""}
                        </div>
                        <div className="col-xs-12 text-left ap-unwrap-content">
                            {j == 0 ? 
                                `(Anniversary Day: ${moment(summary.leaveYearEndDate).add("d", 1).format("MMM D, YYYY")})` : <br/>
                            }
                        </div>
                        <div className="col-xs-12">
                            <div className="row">
                                <div className="col-xs-8 col-xs-offset-3">
                                    {this.state.isElementVisible[idx] ?
                                        <AccrualLogRowMobile accrualLogs={summary.accrualLogs} group={summary.accrualDescription} /> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                );

                /* content.push(
                    <div className={`row ap-accrualgrid-detail-${i%2}`} key={`${i}_${j}`}>
                        <div className="col-xs-12 text-left">
                            <span onClick={() => this.toggleVisibility(idx)} className={this.state.isElementVisible[idx] ? "fa fa-minus ap-good-color" : " fa fa-plus ap-good-color"}> </span> &nbsp;&nbsp;
                            <b> {summary.accrualDescription} </b>
                        </div>
                        <hr />
                        <div className="col-xs-6 text-left">
                            <b>Total Accrued Hours</b>
                        </div>
                        <div className="col-xs-6 text-left">
                            <b>Logged Hours</b>
                        </div>
                        <div className="col-xs-6 text-left">
                            <b>{summary.totalAccruedHours}</b>
                        </div>
                        <div className="col-xs-6 text-left">
                            <b>{summary.loggedHours}</b>
                        </div>
                        <div className="col-xs-12 text-left">
                            <b>Available Hours</b>
                        </div>
                        <div className="col-xs-12 text-left">
                            <b>{summary.availableHours}</b>
                        </div>
                        {
                            this.state.isElementVisible[idx] ?
                                <AccrualLogRowMobile accrualLogs={summary.accrualLogs} group={summary.accrualDescription} /> : null
                        }
                    </div>
                ); */
                rowNo++;
            }
        }

        return (
            <div className="container-fluid ap-accrualgrid mobile">
                <div className="row ap-accrualgrid-header">
                    <div className="col-xs-3">
                        Employee
                    </div>
                    <div className="col-xs-3">
                    </div>
                    <div className="col-xs-2">
                        Total Accrued Hours
                    </div>
                    <div className="col-xs-2">
                        Logged Hours
                    </div>
                    <div className="col-xs-2">
                        Available Hours
                    </div>
                </div>
                {content}
            </div>
        );
    }

}
class AccrualLogRowMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        const accrualLogs = this.props.accrualLogs
        const group = this.props.group;
        let counter = 0;
        return (
            <div>{
                accrualLogs
                    .sort((a, b) => new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime())
                    .map(item => {
                    return (
                        <div className="row ap-border-after" key={group + '_' + counter++}>
                            <div className="col-xs-6 text-left">
                                Date
                            </div>
                            <div className="col-xs-6 text-left">
                                Hours Logged
                            </div>
                            <div className="col-xs-6 text-left">
                                <b> {moment(item.fromDate).format('MM/DD/YYYY')}</b>
                            </div>
                            <div className="col-xs-6 text-left">
                                <b>{item.loggedHours}</b>
                            </div>

                            <div className="col-xs-6 text-left">
                                Status
                            </div>
                            <div className="col-xs-6 text-left">
                                Comments
                            </div>
                            <div className="col-xs-6 text-left">
                                <b>{item.pending == "Y" ? "Pending" : "Processed"}</b>
                            </div>
                            <div className="col-xs-6 text-left text">
                                <b>{item.comment}</b>
                            </div>
                        </div>
                    );
                })
            }
            </div>
        );
    }
}
